import React from "react";
import { Switch } from "react-router-dom";

import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";

import ConsoleComponent from "../containers/console";
import DesignSystemComponent from "../containers/designGuide";
import SignInComponent from "../containers/signIn";
import Home from "../containers/home";
import Admin from "../containers/admin";
import Category from "../containers/Category";
import Menus from "../containers/Menus";
import News from "../containers/news";
import Advertisement from "../containers/advertisement";
import NewsViewPage from "../containers/newsViewPage";
import { ContactUs } from "../containers/moreInfo";
import AdvCategory from "../containers/AdvCategory";
import GovernmentJobsPage from "../containers/GovernmentJobsPage";
import GovernmentJobView from "../containers/GovernmentJobView";
import liveFeed from "../containers/liveFeed";
import admin from "../containers/admin";
import AdsPlatform from "../containers/AdsPlatform";
import TagNewPage from "../containers/tagsNews";
import AdsSignIn from "../containers/AdsSignIn";
import AdsSignUp from "../containers/AdsSignUp";
import AdsSendVerification from "../containers/AdsSendVerification";
import AdsVerifyEmail from "../containers/AdsVerifyEmail";
import AdsCampaign from "../containers/AdsCampaign";
import advWebImageUploader from "../containers/templates/advWebImageUploader";
import PrivacyPolicy from "../containers/moreInfo/privacyPolicy";
import ReturnPolicy from "../containers/moreInfo/returnPolicy";
import TermsConditions from "../containers/moreInfo/termsConditions";
import Subscribe from "../containers/moreInfo/subscribe";
import ProfileComplete from "../containers/profileComplete";
import GovGazetteView from "../containers/GovGazetteView";
import GovGazetteDetailsView from "../containers/GovGazetteDetailsView";
import HomeAdViewModal from "../containers/modal/homeAdViewModal";

const Index = (props) => (
  <Switch>
    <PublicRoute component={ConsoleComponent} path="/" exact />
    <PublicRoute component={Home} path="/" exact />
    <PrivateRoute component={Admin} path="/admin" exact />
    <PrivateRoute component={Admin} path="/admin/category" exact />
    <PrivateRoute component={Admin} path="/admin/menus" exact />
    <PublicRoute component={Admin} path="/admin/adv-category" exact />
    <PublicRoute component={Admin} path="/admin/jobs" exact />
    <PublicRoute component={Admin} path="/admin/jobs-category" exact />
    <PublicRoute component={Admin} path="/admin/tags" exact />
    <PublicRoute component={Admin} path="/admin/widgets" exact />
    <PublicRoute component={admin} path="/admin/live-feed" exact />
    <PublicRoute component={admin} path="/admin/comments" exact />
    <PublicRoute component={admin} path="/admin/advertisement" exact />
    <PublicRoute component={admin} path="/admin/site-map" exact />
    <PublicRoute component={admin} path="/admin/warehouse" exact />
    <PublicRoute component={admin} path="/admin/gazette" exact />
    <PublicRoute component={admin} path="/admin/procuremente" exact />
    <PublicRoute component={Category} path="/category" exact />
    <PublicRoute component={Menus} path="/menus" exact />
    {/*<PublicRoute component={NewsViewPage} path="/news-view" exact />*/}
    <PublicRoute component={Admin} path="/admin/news" exact />
    <PrivateRoute component={News} path="/news" exact />
    <PublicRoute component={NewsViewPage} path="/:keyword/:news_id" exact />
    <PublicRoute component={GovernmentJobsPage} path="/government-jobs" exact />
    <PublicRoute component={GovGazetteView} path="/government-gazette" exact />
    {/* <PublicRoute component={HomeAdViewModal} path="/modal" exact /> */}

    {/* <PublicRoute
      component={GovernmentJobView}
      path="/gov-jobs/gov-job-view"
      exact
    /> */}
    <PublicRoute
      component={GovernmentJobView}
      path="/jobs/:keyword/:job_id"
      exact
    />
    <PublicRoute
      component={GovGazetteDetailsView}
      path="/government-gazette/:gazette_date/:gazette_id"
      exact
    />

    <PublicRoute component={AdsPlatform} path="/ads" exact />
    <PublicRoute component={ReturnPolicy} path="/return-policy" exact />
    <PublicRoute component={PrivacyPolicy} path="/privacy-policy" exact />
    <PublicRoute component={TermsConditions} path="/terms-conditions" exact />
    <PublicRoute component={Subscribe} path="/subscribe" exact />
    <PublicRoute component={AdsSignIn} path="/ads/sign-in" exact />
    <PublicRoute component={AdsSignUp} path="/ads/sign-up" exact />
    <PublicRoute
      component={AdsSendVerification}
      path="/ads/verification"
      exact
    />
    <PublicRoute
      component={AdsVerifyEmail}
      path="/ads/verify-email=:token"
      exact
    />
    <PublicRoute component={AdsCampaign} path="/ads/campaign" exact />
    <PublicRoute component={ProfileComplete} path="/profile-complete" exact />
    <PrivateRoute component={Admin} path="/admin/advertisement" exact />
    <PrivateRoute component={Admin} path="/admin/site-map" exact />
    <PrivateRoute component={Admin} path="/admin/warehouse" exact />
    <PrivateRoute component={Admin} path="/admin/gazette" exact />
    <PrivateRoute component={Admin} path="/admin/procurement" exact />
    <PrivateRoute component={Advertisement} path="/advertisement" exact />
    <PublicRoute component={ContactUs} path="/contact-us" exact />
    <PublicRoute
      component={DesignSystemComponent}
      path="/design-system"
      exact
    />
    <PublicRoute component={SignInComponent} path="/sign-in" exact />
    <PublicRoute component={ConsoleComponent} path="/:module" exact />
    <PrivateRoute component={ConsoleComponent} path="/:module/:module" exact />
    <PublicRoute component={TagNewPage} path="/tag/:module/:module" exact />
  </Switch>
);

export default Index;
